var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('b-img',{staticClass:"bottom-img w-100 d-sm-flex d-md-flex d-lg-none",attrs:{"fluid":"","src":_vm.bottomBanner},on:{"click":function($event){return _vm.goToSales()}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }